<div class="kpi-grid">
	<div class="kpi-card" *ngFor="let kpi of kpis">
		<div class="kpi-card-header">
			<span class="kpi-name">{{ formatLabel(kpi.name) }}</span>
			<p-tag
				[value]="tagLabel(kpi.status)"
				[severity]="tagSeverity(kpi.status)">
			</p-tag>
		</div>
		<div class="kpi-value">{{ formatValue(kpi) }}</div>
		<div class="kpi-target" *ngIf="formatTarget(kpi)">{{ formatTarget(kpi) }}</div>
	</div>
</div>
